import "./custodial_acc.css"
import review from "../../../assets/review.webp";
import Logout from "../../logout/Logout";
import React, {useState} from "react";
import {connect} from "react-redux";
import {setCustodialData, setCustodialType} from "../../../redux/custodial_acc_store";
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import apiClient from "../../../utils/axios";
import ProgressBar from "react-bootstrap/ProgressBar";

const HOST = `${process.env.REACT_APP_API_URL}/api/accounts/step31/`

function CustodialAccount({custodialData, setCustodialData, setCustodialType, appData, personalData}) {

    const {t} = useTranslation()
    const navigate = useNavigate()
    const now = 50

    const isValidDate = (dateString) => {
        const regex = /^\d{2}\/\d{2}\/\d{4}$/;

        if (!regex.test(dateString)) {
            return false;
        }

        const parts = dateString.split('/');
        const year = parseInt(parts[2], 10)
        const month = parseInt(parts[0], 10) - 1;
        const day = parseInt(parts[1], 10);
        const date = new Date(year, month, day);

        return (
            date.getDate() === day &&
            date.getMonth() === month &&
            date.getFullYear() === year
        );
    };

    const [custodialErrors, setCustodialErrors] = useState({
        custodial_first_name: '',
        custodial_last_name: '',
        custodial_middle_name: '',
        custodial_ssn: '',
        custodial_birth: '',
        custodial_type: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        setCustodialErrors({
            custodial_first_name: '',
            custodial_last_name: '',
            custodial_middle_name: '',
            custodial_ssn: '',
            custodial_birth: '',
            custodial_type: ''
        });

        let isValid = true;

        if (!custodialData.custodial_first_name) {
            setCustodialErrors((prevErrors) => ({
                ...prevErrors,
                custodial_first_name: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!custodialData.custodial_last_name) {
            setCustodialErrors((prevErrors) => ({
                ...prevErrors,
                custodial_last_name: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!custodialData.custodial_ssn) {
            setCustodialErrors((prevErrors) => ({
                ...prevErrors,
                custodial_ssn: t('errors.required_field'),
            }));
            isValid = false;
        } else if (custodialData.custodial_ssn.length !== 11) {
            setCustodialErrors((prevErrors) => ({
                ...prevErrors,
                custodial_ssn: t('errors.enter_characters'),
            }));
            isValid = false;
        } else {
            if (custodialData.custodial_ssn === personalData.ssn) {
                setCustodialErrors((prevErrors) => ({
                    ...prevErrors,
                    custodial_ssn: t('errors.main_user_ssn')
                }));
                isValid = false;
            }
        }

        if (!custodialData.custodial_birth || !isValidDate(custodialData.custodial_birth)) {
            setCustodialErrors((prevErrors) => ({
                ...prevErrors,
                custodial_birth: t('errors.valid_date'),
            }));
            isValid = false;
        } else {
            const currentDate = new Date();
            const dobDate = new Date(custodialData.custodial_birth);
            const age = currentDate.getFullYear() - dobDate.getFullYear();

            if (age > 18) {
                setCustodialErrors((prevErrors) => ({
                    ...prevErrors,
                    custodial_birth: t('errors.custodial_year')
                }));
                isValid = false;
            }
        }

        if (!custodialData.custodial_type) {
            setCustodialErrors((prevErrors) => ({
                ...prevErrors,
                custodial_type: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (isValid) {
            setCustodialData(custodialData);
            if (!appData.app_id) alert('Missing app id')

            try {
                await custodialApp()
                navigate('/account')
            } catch (error) {
                setCustodialErrors((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        }
    };

    const handleInputChange = (e) => {
        let {name, value} = e.target;

        if (name === 'custodial_ssn') {
            value = value.replace(/\D/g, '');

            if (value.length === 9) {
                value = value.replace(/^(\d{3})(\d{2})(\d{4})$/, '$1-$2-$3');
            }

            setCustodialData((prevData) => ({
                ...prevData,
                [name]: value
            }));
        }

        if (name === 'custodial_ssn') {
            if (!value) {
                setCustodialErrors((prevErrors) => ({
                    ...prevErrors,
                    custodial_ssn: t('errors.required_field'),
                }));
            } else {
                if (value === personalData.ssn) {
                    setCustodialErrors((prevErrors) => ({
                        ...prevErrors,
                        custodial_ssn: t('errors.main_user_ssn'),
                    }));
                }
                if (value.length === 11 && value.match(/^\d{3}-\d{2}-\d{4}$/)) {
                    setCustodialErrors((prevErrors) => ({
                        ...prevErrors,
                        custodial_ssn: '',
                    }));
                } else {
                    setCustodialErrors((prevErrors) => ({
                        ...prevErrors,
                        custodial_ssn: t('errors.enter_characters'),
                    }));
                }
            }
        }

        if (name === 'custodial_birth') {
            const numericValue = value.replace(/\D/g, '');

            if (numericValue.length <= 2) {
                value = numericValue;
            } else if (numericValue.length <= 4) {
                value = `${numericValue.substr(0, 2)}/${numericValue.substr(2)}`;
            } else {
                value = `${numericValue.substr(0, 2)}/${numericValue.substr(2, 2)}/${numericValue.substr(4, 4)}`;
            }

            const isValid = isValidDate(value);

            setCustodialErrors((prevErrors) => ({
                ...prevErrors,
                [name]: isValid ? '' : t('errors.valid_date'),
            }));

            if (isValid) {
                const currentDate = new Date();
                const dateValue = new Date(value);

                if (name === 'custodial_birth') {
                    const age = currentDate.getFullYear() - dateValue.getFullYear();
                    if (age > 18) {
                        setCustodialErrors((prevErrors) => ({
                            ...prevErrors,
                            [name]: t('errors.custodial_year'),
                        }));
                    }
                }
            }
        }

        setCustodialData({
            ...custodialData,
            [name]: value,
        });
    }

    const formatDateInput = (dateString) => {
        if (!dateString) return dateString
        return dateString.replace(/\D/g, '').replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3');
    };

    const formatDateInputAPI = (dateString) => {
        if (!dateString) return dateString
        return dateString.replace(/\D/g, '').replace(/(\d{2})(\d{2})(\d{4})/, '$3-$1-$2');
    };

    const handleCustodialTypeChange = (newCustodialType) => {
        setCustodialType(newCustodialType);
    };

    const custodialApp = async () => {
        const URL = HOST + appData.app_id

        try {
            const parsedCustodialData = {
                ...custodialData,
                custodial_birth: formatDateInputAPI(custodialData.custodial_birth)
            }

            const response = await apiClient.put(URL, {
                ...parsedCustodialData
            }, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            })

            if (response.data && response.data.status &&
                ['400', '401', '403', '404', '405', '408', '429', '500', '501', '502', '503', '504', '505'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }
        } catch (error) {
            throw error;
        }
    }

    return (
        <div className="flex">
            <div className="left_side">
                <img className="w-full" src={review} alt=""/>
            </div>
            <div className="right_side">
                <div className="flex justify-content-between align-items-baseline">
                    <div role="progressbar" id="combo" aria-label="progress" className="w-100">
                        <ProgressBar now={now} label={`${now}%`} visuallyHidden/>
                    </div>
                    <Logout/>
                </div>
                <div>
                    <p className="custodial_acc_heading text-center font-normal uppercase text-xl">
                        {t('custodial.thanks')} {personalData.firstName} {personalData.lastName}. {t('custodial.provide_info')}
                    </p>
                    <form onSubmit={handleSubmit}>
                        <div className="flex flex-column pt-7 gap-4">
                            <div className="flex flex-wrap gap-3">
                                <div className="flex flex-column w-full">
                                    <input placeholder={t('personal.first_name')}
                                           className="custodial_acc_inp w-full flex align-items-center p-2"
                                           type="text"
                                           name="custodial_first_name"
                                           value={custodialData.custodial_first_name}
                                           onChange={handleInputChange}
                                    />
                                    {custodialErrors.custodial_first_name &&
                                        <p className="error">{custodialErrors.custodial_first_name}</p>}
                                </div>
                                <div className="flex flex-column w-full">
                                    <input placeholder={t('specialty.middle_name')}
                                           className="custodial_acc_inp w-full flex align-items-center p-2"
                                           type="text"
                                           name="custodial_middle_name"
                                           value={custodialData.custodial_middle_name}
                                           onChange={handleInputChange}
                                    />
                                </div>
                                <div className="flex flex-column w-full">
                                    <input placeholder={t('personal.last_name')}
                                           className="custodial_acc_inp w-full flex align-items-center p-2"
                                           type="text"
                                           name="custodial_last_name"
                                           value={custodialData.custodial_last_name}
                                           onChange={handleInputChange}
                                    />
                                    {custodialErrors.custodial_last_name &&
                                        <p className="error">{custodialErrors.custodial_last_name}</p>}
                                </div>
                                <div className="custodial_acc_inp_error flex flex-column">
                                    <input placeholder={t('personal.ssn')}
                                           className="custodial_acc_inp w-full flex align-items-center p-2"
                                           type="text"
                                           name="custodial_ssn"
                                           maxLength={11}
                                           value={custodialData.custodial_ssn}
                                           onChange={handleInputChange}
                                    />
                                    {custodialErrors.custodial_ssn &&
                                        <p className="error">{custodialErrors.custodial_ssn}</p>}
                                </div>
                                <div className="custodial_acc_inp_error flex flex-column">
                                    <input
                                        className="custodial_acc_inp w-full flex align-items-center p-2"
                                        placeholder={t('personal.date_of_birth')}
                                        type="text"
                                        name="custodial_birth"
                                        value={formatDateInput(custodialData.custodial_birth)}
                                        onChange={handleInputChange}
                                    />
                                    {custodialErrors.custodial_birth &&
                                        <p className="error">{custodialErrors.custodial_birth}</p>}
                                </div>
                                <div className="flex gap-3 pt-2">
                                    <div className="flex gap-2">
                                        <input type="radio"
                                               name="UGMA"
                                               value="UGMA"
                                               onChange={() => handleCustodialTypeChange('UGMA')}
                                               checked={custodialData.custodial_type === "UGMA"}
                                        />
                                        <label>UGMA</label>
                                    </div>
                                    <div className="flex gap-2">
                                        <input type="radio"
                                               name="UTMA"
                                               value="UTMA"
                                               onChange={() => handleCustodialTypeChange('UTMA')}
                                               checked={custodialData.custodial_type === "UTMA"}
                                        />
                                        <label>UTMA</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className="flex sm:justify-content-between justify-content-center align-items-center gap-2 sm:flex-row flex-column-reverse row-gap-3 pt-7">
                            <Link to="/affiliation" className="no-underline">
                                <button type="submit" className="back_btn">{t('back_btn')}</button>
                            </Link>
                            <button className="continue_btn" type="submit">{t('next_btn')}</button>
                        </div>

                        <div>
                            {custodialErrors.submitError && (
                                <div className="text-red-500 text-center">
                                    {custodialErrors.submitError}
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    custodialData: state.custodialData,
    appData: state.appData,
    personalData: state.personalData
});

const mapDispatchToProps = {
    setCustodialData,
    setCustodialType
};

export default connect(mapStateToProps, mapDispatchToProps)(CustodialAccount);